import ExecutableFix from './ExecutableFix';


export default {
  __init__: [
    ExecutableFix
  ]
};
